export const REQUEST_STATUSES: string[] = [
  'new',
  'progress',
  'draft',
  'complete',
  'canceled',
  'hold',
];

export const STATUSES = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  TERMINATED: 'TERMINATED',
  COMPLETED: 'COMPLETED'
};
